module.exports = __webpack_public_path__ + "static/img/cfca.13c1d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cfca.png
// module id = KBpM
// module chunks = 1